import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=6db0bb2e&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db0bb2e')) {
      api.createRecord('6db0bb2e', component.options)
    } else {
      api.reload('6db0bb2e', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=6db0bb2e&", function () {
      api.rerender('6db0bb2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/logo.vue"
export default component.exports